import { handle_popup, loading_popup } from './handle_popup.js'
import { init_q, printProduct, q } from './print_products.js'
import { setupHidePrices, priceStatus } from './hide_prices.js'


function cart_events() {
    const btns = document.querySelectorAll(`[data-name="add-to-cart"]`)
    btns.forEach((btn) => {
        btn.addEventListener('click', async function (e) {
            e.stopPropagation()
            if (loading_popup) return null
            else {
                const e = {
                    name: 'clickedObjectIDs',
                    url: '/products',
                    payload: {
                        product_id: this.dataset.prodId,
                        ...q,
                    },
                }
                try {
                    await handleEvent(e, undefined, { require_location: true })
                } catch (e) { }
                handle_popup(this.dataset.prodId)
            }
        })
    })
}

window.addEventListener('DOMContentLoaded', () => {
    cart_events()
    setupHidePrices()
})
